"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useActionInstance(selector) {
  const {
    item: actionInstance,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.ActionInstance,
    selector,
    (integrationApp) => selector ? integrationApp.actionInstance(selector) : void 0
  );
  async function run(input) {
    return accessor?.run(input);
  }
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  async function openConfiguration(options) {
    return accessor?.open(options);
  }
  return {
    actionInstance,
    accessor,
    refresh,
    setup,
    reset,
    openConfiguration,
    run,
    ...rest
  };
}

export { useActionInstance };
